import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowLeft"><Path d="M10 5.5L3.5 12L10 18.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4 12H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowLeft;
